import React, { useContext } from 'react';

import assetModalContext from '@components/asset/modal/tabs/edit/asset_modal_context';
import {
  ActionTypes,
  CustomFieldPayloadOperations,
  CreateCustomFieldsDispatch,
} from '@components/asset/modal/tabs/edit/EditTabTypes';
import { CreateCustomFieldParams } from '@api/v4/assets/customFieldTypes';

interface AddCustomFieldProps {
  createCustomFieldMaps: CreateCustomFieldParams[];
}

interface AddCustomFieldScopedContext {
  state: {
    editState: AddCustomFieldProps;
  };
  dispatch: CreateCustomFieldsDispatch;
}

const AddCustomField = (): JSX.Element => {
  const { state, dispatch }: AddCustomFieldScopedContext = useContext(assetModalContext);

  const createCustomFieldMap = (): void => {
    dispatch({
      type: ActionTypes.CreateCustomFieldMaps,
      payload: { operation: CustomFieldPayloadOperations.Create }
    });
  };

  const updateCustomFieldMap = ({ index, key, value }: { index: number; key: string; value: string }): void => {
    dispatch({
      type: ActionTypes.CreateCustomFieldMaps,
      payload: { operation: CustomFieldPayloadOperations.Update, index, key, value }
    });
  };

  const deleteCustomFieldMap = ({ index }: { index: number }): void => {
    dispatch({
      type: ActionTypes.CreateCustomFieldMaps,
      payload: { operation: CustomFieldPayloadOperations.Delete, index }
    });
  };

  return (
    <div className="add-custom-field-container">
      <button
        className="add-custom-field-row"
        onClick={(): void => createCustomFieldMap()}
        type="button"
      >
        <span className="bff-plus" />
        {bfTranslate('Add Custom Field')}
      </button>
      <ul className="custom-field-list new-custom-fields-list">
        {
          state.editState.createCustomFieldMaps.map((customField: CreateCustomFieldParams, index: number) => (
            <li
              key={`new-custom-field-${index}`}
              className="custom-field-row"
            >
              <div className="custom-field-key">
                <input
                  aria-label="Custom Field Key"
                  className="custom-field-input"
                  onChange={(e: InputChangeEvent): void => updateCustomFieldMap(
                    { key: e.currentTarget.value, index, value: customField.value }
                  )}
                  placeholder={bfTranslate('Key')}
                  value={customField.key}
                />
              </div>
              <div className="custom-field-value">
                <input
                  aria-label="Custom Field Value"
                  className="custom-field-input"
                  onChange={(e: InputChangeEvent): void => updateCustomFieldMap(
                    { value: e.currentTarget.value, index, key: customField.key }
                  )}
                  placeholder={bfTranslate('Value')}
                  value={customField.value}
                />
                <button
                  aria-label="Remove Custom Field Row"
                  className="remove-custom-field-row"
                  onClick={(): void => deleteCustomFieldMap({ index })}
                  type="button"
                >
                  <span className="bff-close" />
                </button>
              </div>
            </li>
          ))
        }
      </ul>
    </div>
  );
};

export default AddCustomField;
